import {
  COMBINED_INVENTORY_RESET,
  COMBINED_INVENTORY_REQUEST,
  COMBINED_INVENTORY_SUCCESS,
  COMBINED_INVENTORY_FAILURE,
  COMBINED_INVENTORY_SET_QUERY,
  COMBINED_INVENTORY_SET_FILTER,
} from 'Constants/redux';
import { COMBINED_INVENTORY_SEARCH } from '../constants/redux';

const INITIAL_STATE = {
  categories: [],
  inventory: [],
  productType: 'all',
  numberPer: 10,
  page: 0,
  filter: {},
  query: '',
  pagination: {},
  loading: false,
  pagesRemaining: true,
};

const filterInventoryDuplicates = (inventory, cmpFunction) => {
  if (!inventory || !inventory.length) {
    return [];
  }

  return inventory.reduce((uniqueItems, currentItem) => {
    // Check if the current item is a duplicate of any item in the uniqueItems array
    const isDuplicate = uniqueItems.some(uniqueItem =>
      cmpFunction(uniqueItem, currentItem)
    );

    // If it's not a duplicate, add it to the uniqueItems array
    if (!isDuplicate) {
      uniqueItems.push(currentItem);
    }

    return uniqueItems;
  }, []);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COMBINED_INVENTORY_RESET:
      const { shouldResetFilter } = action.payload;
      const filter = shouldResetFilter ? {} : state.filter;

      return {
        ...state,
        inventory: [],
        filter,
        loading: false,
        pagesRemaining: true,
        pagination: {},
      };
    case COMBINED_INVENTORY_REQUEST:
      return { ...state, loading: true };
    case COMBINED_INVENTORY_FAILURE:
      return { ...state, loading: false };
    case COMBINED_INVENTORY_SUCCESS:
      const newProducts = action.response.data.inventories;
      let totalProducts = newProducts;
      if (!action.reset) {
        totalProducts = state.inventory.concat(totalProducts);
      }
      //remove products that have already been inserted
      totalProducts = filterInventoryDuplicates(totalProducts, (a,b) => {
        return a.id === b.id && a.productType === b.productType;
      })
      const pagesRemaining =
        totalProducts.length <
        action.response.data.meta.pagination.totalObjects;

      let queryResponseTimestamp = state.queryResponseTimestamp;
      if (action.response.data.meta.searchedQuery !== state.searchedQuery) {
        queryResponseTimestamp = Date.now();
      }

      return {
        ...state,
        inventory: totalProducts,
        pagination: action.response.data.meta.pagination,
        serialHit: action.response.data.meta.serialHit || false,
        productType: action.productType,
        pagesRemaining: pagesRemaining,
        isInfiniteLoading: false,
        loading: false,
        queryResponseTimestamp: queryResponseTimestamp,
        searchedQuery: action.response.data.meta.searchedQuery,
      };
    case COMBINED_INVENTORY_SEARCH:
      return {
        ...state,
        loading: true,
      };
    case COMBINED_INVENTORY_SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case COMBINED_INVENTORY_SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    default:
      return state;
  }
};
